import { render } from "./EmployeeSwCertificationRecords.vue?vue&type=template&id=61d0c0e7&scoped=true"
import script from "./EmployeeSwCertificationRecords.vue?vue&type=script&lang=js"
export * from "./EmployeeSwCertificationRecords.vue?vue&type=script&lang=js"

import "./EmployeeSwCertificationRecords.vue?vue&type=style&index=0&id=61d0c0e7&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d0c0e7"]])

export default __exports__